import SocialLogin from 'react-social-login';

import SocialMediaButton from './SocialMediaButton';

export default SocialLogin(SocialMediaButton);
